import Tooltip from '../Tooltip/Tooltip'
import classes from './ListButton.module.scss'
import {
  Color,
  Paragraph
} from '../..'
import { FiMoreHorizontal } from 'react-icons/fi'
import { forwardRef } from 'react'

export interface Props {
  onClick: () => void
  withTooltips?: boolean
  counter?: number
  title?: string
  label?: string
  isDisabled?: boolean
  isStayFocus?: boolean
}

// forwardRef is used here because this button can be used as the anchor for a PopOut
// this works the same as any other component
const ListButton = forwardRef((
  {
    onClick,
    withTooltips = true,
    counter,
    title = 'What&apos;s This?',
    label,
    isDisabled = false,
    isStayFocus
  }: Props,
  ref: any
) => {
  const renderContent = () => counter
    ? (
      <Paragraph>
        <small>
          <Color variant='theme-description-text'>
            {
              counter < 100
                ? `+${counter}`
                : '+99'
            }
          </Color>
        </small>
      </Paragraph>
    )
    : (
      <FiMoreHorizontal
        aria-hidden
        size='18px'
      />
    )

  const counterClass = counter
    ? classes.counter
    : ''

  const isFocusClass = isStayFocus
    ? classes.isFocus
    : ''

  const getListButtonClass = () => [
    classes.ListButton,
    counterClass,
    isFocusClass
  ].filter(classStyle => classStyle).join(' ')

  return (
    <button
      aria-label={label}
      className={getListButtonClass()}
      disabled={isDisabled}
      onClick={onClick}
      ref={ref}
      title={
        !withTooltips
          ? title
          : undefined
      }
      type='button'
    >
      {
        withTooltips
          ? (
            <Tooltip label={title}>
              {renderContent()}
            </Tooltip>
          )
          : renderContent()
      }
    </button>
  )
}
)

export default ListButton
